import React from 'react'
import styled from 'styled-components'
import CrosshairPreview from '@/components/Crosshair/CrosshairPreview'
import PreviewCard from './PreviewCard'

// --- Styled Components ---

const Crosshair_FloatingCrosshairLabel = styled.div`
    position: absolute;
    top: 8px;
    left: 8px;
    background: rgba(13, 17, 23, 0.85);
    border: 1px solid rgba(99, 102, 241, 0.5);
    border-radius: 6px;
    padding: 3px 10px;
    font-size: 10px;
    color: #fff;
    font-weight: 800;
    pointer-events: none;
    letter-spacing: 1px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
    z-index: 5;
    text-transform: uppercase;
    font-family: var(--font-chakra);
    display: flex;
    align-items: center;
    gap: 6px;
    

    &::before {
        content: '';
        width: 6px;
        height: 6px;
        background: #6366f1;
        border-radius: 50%;
        box-shadow: 0 0 8px #6366f1;
    }
`

// --- Main Component ---

export default function CrosshairSidebarPreview({
    data, // crosshair
    isActive,
    isDisabled, // usually !configName
    onToggle,
    onClick,
    t,
    ...props
}) {
    const c = data || {}

    return (
        <PreviewCard
            isActive={isActive}
            isDisabled={isDisabled}
            onClick={onClick}
            onToggle={onToggle}
            label={t('CROSSHAIR_TITLE')}
            style={{ minHeight: '164px', padding: 0, ...props.style }}
            {...props}
        >
            <Crosshair_FloatingCrosshairLabel>
                {(c.cl_crosshairstyle === 4 || !c.cl_crosshairstyle)
                    ? 'STATIC'
                    : 'DYNAMIC'}
            </Crosshair_FloatingCrosshairLabel>
            <CrosshairPreview isActive={isActive} minimal={true} />
        </PreviewCard>
    )
}
